import { ResourceCalendar } from '@/components/calendar/ResourceCalendar';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { WhatIfScenario } from '@/types';
import { type PlanPreviewScenario } from '@/types/resourceRequest';

interface DashboardProps {
  heatmapMode?: boolean;
  /** Pre-selects a project in the heatmap filter when navigating from Project Staffing */
  initialProjectFilter?: string | null;
  /** Scenario handed off from the heatmap suggestions panel — calendar opens in what-if mode */
  whatIfScenario?: WhatIfScenario | null;
  /** Called when the user commits or discards a what-if scenario */
  onWhatIfComplete?: (navigateBackToHeatmap?: boolean) => void;
  /** Heatmap-mode only: called when Apply/Assign is pressed in the suggestions panel */
  onNavigateToCalendarWithWhatIf?: (scenario: WhatIfScenario) => void;
  /** Plan preview scenario from the Open Demand page — shows ghost bookings on the calendar */
  planPreviewScenario?: PlanPreviewScenario | null;
  /** Called when the user dismisses the plan preview banner */
  onPlanPreviewClose?: () => void;
}

export function Dashboard({
  heatmapMode = false,
  initialProjectFilter,
  whatIfScenario,
  onWhatIfComplete,
  onNavigateToCalendarWithWhatIf,
  planPreviewScenario,
  onPlanPreviewClose,
}: DashboardProps) {
  return (
    // h-full + overflow-hidden: fills the flex-1 main area and prevents
    // this container from generating its own scrollbar — Bryntum Scheduler
    // manages all scrolling internally.
    <div className="h-full overflow-hidden">
      <ErrorBoundary>
        <ResourceCalendar
          initialHeatmapMode={heatmapMode}
          initialProjectFilter={initialProjectFilter}
          whatIfScenario={whatIfScenario}
          onWhatIfComplete={onWhatIfComplete}
          onNavigateToCalendarWithWhatIf={onNavigateToCalendarWithWhatIf}
          planPreviewScenario={planPreviewScenario}
          onPlanPreviewClose={onPlanPreviewClose}
        />
      </ErrorBoundary>
    </div>
  );
}
